import { editUser } from "@State/index";
import { getUser } from "@State/index";
import { FetchOnceAutocomplete } from "@View/common/form/control/FetchOnceAutocomplete";
import ButtonSave from "@View/components/buttons/ButtonSave";
import DefaultInput from "@View/components/formInputs/DefaultInput";
import DefaultSelect from "@View/components/formInputs/DefaultSelect";
import ModalLayout from "@View/components/ModalLayout";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { searchClients } from "@Utils/commonAPI";
import { canEditUser, getRole } from "@Security/stateHelpers";
import getAPI from "@API/index";

const EditUserPage = ({ userId, open, handleClose }) => {
  const dispatch = useDispatch();
  let history = useHistory();
  const { t } = useTranslation();

  const user = useSelector((state) => state.user.user);
  const [newData, setNewData] = useState({});

  useEffect(() => {
    dispatch(getUser(userId));
  }, [dispatch, userId]);

  useEffect(() => {
    if (userId === user.id) {
      setNewData({ ...user });
    }
  }, [user, userId]);

  let deleteObjFunc = (roleV) => {
    if (roleV === "Admin") {
      setNewData((prevData) => {
        let newData = { ...prevData };
        delete newData.CustomerId;
        delete newData.ClientId;
        delete newData.clientName;
        delete newData.customerName;
        return newData;
      });
    } else if (
      roleV === "CustomerUser" ||
      roleV === "CustomerManager" ||
      roleV === "CustomerEmployee"
    ) {
      setNewData((prevData) => {
        let newData = { ...prevData };
        delete newData.ClientId;
        delete newData.clientName;
        return newData;
      });
    } else if (roleV === "ClientUser") {
      setNewData((prevData) => {
        let newData = { ...prevData };
        delete newData.CustomerId;
        delete newData.customerName;
        return newData;
      });
    }
  };

  const handleChange = (value, label) => {
    setNewData({ ...newData, [label]: value });
  };

  const handleClientChange = (value) => {
    let obj = {
      ClientId: value.id,
      clientName: value.name,
    };
    setNewData({ ...newData, ...obj });
  };

  const handleCustomerChange = (value) => {
    let obj = {
      CustomerId: value.id,
      customerName: value.name,
    };
    setNewData({ ...newData, ...obj });
  };

  const handleClick = async (event) => {
    event.preventDefault();
    try {
      await dispatch(editUser(newData, history));
      handleClose();
    } catch (e) {
      console.error("[editUser]", e);
    }
  };

  const types = [
    { value: "Admin" },
    { value: "CustomerUser" },
    { value: "CustomerManager" },
    { value: "CustomerEmployee" },
    { value: "CustomerGuest" },
    { value: "ClientUser" },
    { value: "ClientGuest" },
  ];

  const fetchCustomerOptions = () =>
    getAPI()
      .request({ url: "/api/Customer/search" })
      .then((result) => result.map((e) => ({ id: e.guid, name: e.name })));

  const editRoleDisabled = [
    "CustomerUser",
    "CustomerManager",
    "CustomerEmployee",
    "CustomerGuest",
  ].includes(getRole());

  const editable = canEditUser();

  const footer = editable ? (
    <ButtonSave marginTop="0">buttons.Save</ButtonSave>
  ) : null;

  return (
    <ModalLayout
      open={open}
      onClose={handleClose}
      title="h1.Edit User"
      subtitle={user.email}
      onSubmit={handleClick}
      footer={footer}
    >
      <DefaultInput
        value={newData.userName}
        label="Login"
        disabled={!editable}
        onChange={(event) => handleChange(event, "userName")}
      />
      <DefaultInput
        value={newData.email}
        label="inputs.Email"
        disabled={!editable}
        onChange={(event) => handleChange(event, "email")}
      />
      <DefaultInput
        value={newData.fullName}
        label="FullName"
        disabled={!editable}
        onChange={(event) => handleChange(event, "fullName")}
      />
      <DefaultSelect
        value={`${newData.role}`}
        label="inputs.Role"
        style={{
          width: "100%",
          ...(editRoleDisabled
            ? { cursor: "not-allowed", opacity: ".6" }
            : {}),
        }}
        dropdowns={types}
        disabled={editRoleDisabled}
        onChange={(value) => {
          handleChange(value, "role");
          deleteObjFunc(value);
        }}
      />

      {[
        "CustomerUser",
        "CustomerGuest",
        "CustomerEmployee",
        "CustomerManager",
      ].includes(newData.role) && getRole() !== "CustomerUser" ? (
        <FetchOnceAutocomplete
          value={
            newData.customerName === undefined
              ? ""
              : `${newData.customerName}`
          }
          id="customer"
          label={t("Customer")}
          onChange={handleCustomerChange}
          fetchOptions={fetchCustomerOptions}
        />
      ) : null}

      {newData.role === "ClientUser" || newData.role === "ClientGuest" ? (
        <FetchOnceAutocomplete
          id="client"
          value={
            newData.clientName === undefined ? "" : `${newData.clientName}`
          }
          label={t("Client")}
          onChange={handleClientChange}
          fetchOptions={searchClients}
        />
      ) : (
        ""
      )}
    </ModalLayout>
  );
};

export default EditUserPage;
